// extracted by mini-css-extract-plugin
module.exports = {"container":"__404_container__2RXjK","title":"__404_title__37hoS","description":"__404_description__3-_iq","button":"__404_button__2j6Jt","a":"__404_a__ENVSX"};